<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-bundle-christmas-table ref="table" :items="values" :toolbar="false"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {SmartOfferChristmasConfig} from "@/modules/redactor/models/smart-offer/bundle-christmas/SmartOfferChristmasConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RBundleChristmasTable from "@/modules/redactor/views/smart-offer/bundle-christmas/r-bundle-christmas-table.vue";

export default {
  name: "r-bundle-christmas-panel",
  components: {RBundleChristmasTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Offers"),
    items: VueTypes.arrayOf(SmartOfferChristmasConfig)
  },
  data: () => ({
    localItems: []
  }),
  computed: {
    values() {
      return Array.isArray(this.items) ? this.items : this.localItems;
    }
  },

  mounted() {
    if (!Array.isArray(this.items)) {
      this.$emit('update:items', []);
    }
  },

  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>